import { getValidColor, isReadOnly } from '~/helpers'

import { getCountryFromCurrency } from './helpers'

type AppInfoDto = (data: GetAppInfoResponse) => AppInfoDTOData

const currencyHiddenDecimals = new Set(['COP'])

/**
 * Moedas que não usam centavos (ex.: COP) são exibidas sem casas decimais.
 */
export const getCurrencyUseCents = (currencyCode: string) =>
  !currencyHiddenDecimals.has(currencyCode)

/**
 * Calcula o provider de pagamento baseado no código da moeda
 * @param currencyCode - Código da moeda (ex: 'PEN', 'BRL')
 * @returns PaymentProvider - 'mercado_pago' para PEN, 'default' para outros
 */
const getPaymentProvider = (currencyCode: string): PaymentProvider => {
  return currencyCode === 'PEN' ? 'mercado_pago' : 'default'
}

const appInfoDTO: AppInfoDto = data => {
  const currencyCode = data?.currency_code || 'BRL'
  const country = getCountryFromCurrency(currencyCode) || 'BR'

  const currencyUseCents = getCurrencyUseCents(currencyCode)

  return {
    accountId: data?.account_id,

    name: data?.name,
    description: data?.description,
    logo: data?.logo,
    headerLogo: data?.header_logo,
    headerTheme: data?.header_theme || 'light',

    isWhiteLabel: data?.is_white_label,
    isNetwork: data?.is_network,
    logoWhiteLabel: data?.logo_white_label,
    domain: data?.domain,

    favicon: data?.favicon_url,
    ogImage: data?.image_og,
    colors: {
      header: getValidColor(data?.header_color),
      primary: data?.theme?.primary_color
        ? getValidColor(data.theme.primary_color)
        : null,
      secondary: data?.theme?.secondary_color
        ? getValidColor(data.theme.secondary_color)
        : null,
      dark: data?.theme?.dark_color
        ? getValidColor(data.theme.dark_color)
        : null
    },

    callbackLogoutUrl: data?.callback_logout_url || null,

    faqUrl: data?.faq_url,
    newTicketURL:
      data?.new_ticket_url ||
      'https://newtail.freshdesk.com/support/tickets/new',

    timezone: data?.timezone,
    currencyCode,
    country,
    currencyUseCents,
    hasRecharge: data?.has_recharge && !isReadOnly(),
    rechargeMinValue: data?.min_recharge_value,
    rechargeEmail: data?.recharge_email || 'comercial@newtail.com.br',

    externalSigupUrl: data?.external_signup_url || null,

    paymentProvider: getPaymentProvider(currencyCode)
  }
}

export default appInfoDTO
